import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkCalendarNavigationPagination } from './uitk-calendar-navigation-pagination.esm.js';
import { UitkCalendarNavigationScrolling } from './uitk-calendar-navigation-scrolling.esm.js';
import '../uitk-calendar.css';

var UitkCalendarNavigation = function (props) {
    var navType = props.navType, rest = __rest(props, ["navType"]);
    UitkCalendarNavigation.displayName = 'UitkCalendarNavigation';
    if (navType === 'scrolling') {
        return React.createElement(UitkCalendarNavigationScrolling, __assign({ navType: "scrolling" }, rest));
    }
    return React.createElement(UitkCalendarNavigationPagination, __assign({}, rest, { navType: navType }));
};

export { UitkCalendarNavigation };
